module.exports = __webpack_public_path__ + "static/POSTERIOR-d7c4fb68d87657483a87afcd3359c448.webp";